/* ============================================================
   Cardio Online — lazy, device-aware mega menu
   Rebuilt 2026-06-01

   What changed vs the stock Flex behaviour:
   - At page load NOTHING is cloned. Only the server-rendered
     "source" panels remain in the DOM (good for SEO, lightweight).
   - DESKTOP: a menu's panel is cloned into the nav the first time
     the shopper opens it (hover or click), then reused.
   - MOBILE: panels are built only on a mobile viewport — exactly
     the same build the theme did before, just never on desktop.
   - Resizing across the 768px breakpoint builds whichever side is
     now needed.
   - Theme editor: builds eagerly so panels are visible while editing.
   - Idempotent: safe even if this file is referenced more than once.
   ============================================================ */
(function () {
  // NOTE: jQuery ($) is referenced lazily inside the methods below, which run
  // on/after DOMContentLoaded — by then jQuery (deferred in <head>) is loaded.
  // We must NOT capture it at parse time: this file loads as a non-deferred
  // body script that executes BEFORE the deferred jQuery, so window.jQuery is
  // still undefined here. Using the global $ inside methods avoids that.
  function $() { return window.jQuery.apply(null, arguments); }

  window.PXUTheme = window.PXUTheme || {};
  var MM = window.PXUTheme.jsMegaMenu = window.PXUTheme.jsMegaMenu || {};

  // Persist state across repeated loads of this file
  MM._registry = MM._registry || {};
  MM._setupDone = MM._setupDone || false;

  MM._isMobile = function () {
    return window.matchMedia('(max-width: 768px)').matches;
  };

  MM._inEditor = function () {
    return !!(window.Shopify && window.Shopify.designMode);
  };

  // ------------------------------------------------------------
  // Section lifecycle entry point (called once per mega-menu section)
  // ------------------------------------------------------------
  MM.init = function ($section) {
    this.enableMobileMegaMenu = document.body.dataset.enableMobileMegaMenu === 'true';

    var data = (window.PXUTheme.getSectionData && window.PXUTheme.getSectionData($section)) || {};
    var parentLink = (data.parent_link || '').toString();
    var sectionId = data.section_id;
    if (!parentLink || !sectionId) { return; }

    var $megaMenu = $section.find('.mega-menu__' + sectionId);

    // Register (or refresh) this menu without cloning anything yet
    var entry = this._registry[parentLink];
    if (!entry) {
      entry = this._registry[parentLink] = {
        parentLink: parentLink,
        sectionId: sectionId,
        enableTabs: data.enable_tabs,
        $megaMenu: $megaMenu,
        desktopBuilt: false,
        mobileBuilt: false
      };
    } else {
      // Re-init (e.g. theme editor re-render): refresh source + rebuild
      entry.$megaMenu = $megaMenu;
      entry.sectionId = sectionId;
      entry.enableTabs = data.enable_tabs;
      if (this._inEditor()) {
        $('.header__item[data-navlink-handle="' + parentLink + '"] .mega-menu__section, .vertical-header__first-level[data-navlink-handle="' + parentLink + '"] .mega-menu__section').remove();
        entry.desktopBuilt = false;
        entry.mobileBuilt = false;
      }
    }

    // Mark the desktop trigger as a mega-menu parent (cheap — no clone)
    var $parent = $('.header__item[data-navlink-handle="' + parentLink + '"], .vertical-header__first-level[data-navlink-handle="' + parentLink + '"]');
    if ($parent.length) {
      $parent.addClass('has-mega-menu');
      $parent.find('.header__link').removeClass('is-arrowless');
      $parent.find('.navbar-dropdown').addClass('is-invisible is-hidden');
    }

    this._globalSetup();

    // Build eagerly in the editor; on real phones build the mobile panel at load
    if (this._inEditor()) {
      this._buildDesktop(parentLink);
      if (this.enableMobileMegaMenu) { this._buildMobile(parentLink); }
    } else if (this.enableMobileMegaMenu && this._isMobile()) {
      this._buildMobile(parentLink);
    }
  };

  // ------------------------------------------------------------
  // Desktop: clone the source panel into the nav item (once)
  // ------------------------------------------------------------
  MM._buildDesktop = function (parentLink) {
    var entry = this._registry[parentLink];
    if (!entry || entry.desktopBuilt) { return; }

    var $parent = $('.header__item[data-navlink-handle="' + parentLink + '"], .vertical-header__first-level[data-navlink-handle="' + parentLink + '"]');
    if (!$parent.length) { return; }

    $parent.find('.mega-menu__section').remove();
    $parent.find('.navbar-dropdown').addClass('is-invisible is-hidden');
    $parent.find('.header__link').removeClass('is-arrowless');
    entry.$megaMenu.clone().appendTo($parent);
    $parent.addClass('has-mega-menu');

    entry.desktopBuilt = true;
    this.initTabs();
  };

  // ------------------------------------------------------------
  // Mobile: clone the source panel into the mobile drawer (once)
  // (Same logic the theme used before — just gated to mobile)
  // ------------------------------------------------------------
  MM._buildMobile = function (parentLink) {
    var entry = this._registry[parentLink];
    if (!entry || entry.mobileBuilt) { return; }

    var $megaMenu = entry.$megaMenu;
    var $parentMobileElement = $('[data-mobile-menu-navlink-handle="' + parentLink + '"]');
    if (!$parentMobileElement.length) { return; }

    if ($parentMobileElement.find('.has-no-submenu').length) {
      $parentMobileElement.find('a.mobile-menu__item').addClass('mobile-menu-link');
      $parentMobileElement.find('a').after('<span class="close-dropdown" aria-expanded="false"></span>');
      $parentMobileElement.find('.submenu__label').after('<ul class="mobile-submenu__list mobile-menu__submenu has-mega-menu" data-mobile-submenu-first-level-list></ul>');
      var $mobileMenuToggle = $parentMobileElement.find('[data-mobile-menu-has-toggle]');
      $($mobileMenuToggle).attr('data-mobile-menu-has-toggle', true);
      var $parentListA = $parentMobileElement.find('.has-mega-menu');
      var $mmCloneA = $megaMenu.clone();
      $mmCloneA.appendTo($parentListA);
      this.buildMobileAccordion($mmCloneA);
    } else {
      var $parentListB = $parentMobileElement.find('[data-mobile-submenu-first-level-list]');
      $parentListB.empty().addClass('has-mega-menu').removeClass('has-dropdown');
      var $mmCloneB = $megaMenu.clone();
      $mmCloneB.appendTo($parentListB);
      this.buildMobileAccordion($mmCloneB);
    }
    entry.mobileBuilt = true;
  };

  MM._buildAllMobile = function () {
    var self = this;
    Object.keys(this._registry).forEach(function (k) { self._buildMobile(k); });
  };

  // ------------------------------------------------------------
  // One-time global wiring (open/close + resize handling)
  // ------------------------------------------------------------
  MM._globalSetup = function () {
    if (this._setupDone) { return; }
    this._setupDone = true;
    var self = this;

    // .dropdown-click--false present => open on hover; otherwise open on click
    var hoverMode = $('.dropdown-click--false').length > 0;

    function openFor($item) {
      $('.mega-menu__section').removeClass('is-active');
      if ($item.hasClass('has-mega-menu')) {
        var handle = $item.data('navlink-handle');
        self._buildDesktop(handle);
        $item.find('.mega-menu__section').addClass('is-active');
      }
    }

    if (hoverMode) {
      $('.navbar-item, .header__brand, .header__search').on('mouseover', function () {
        openFor($(this));
      });
      $('.navbar').on('mouseleave', function () {
        $('.mega-menu__section').removeClass('is-active');
      });
    } else {
      $('.navbar-item, .header__brand, .header__search').on('click touchstart', function () {
        openFor($(this));
      });
    }

    // Build the correct side when crossing the mobile/desktop breakpoint
    var lastMobile = this._isMobile();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nowMobile = self._isMobile();
        if (nowMobile === lastMobile) { return; }
        lastMobile = nowMobile;
        if (nowMobile && self.enableMobileMegaMenu) { self._buildAllMobile(); }
        // desktop panels build lazily on hover/click — nothing to do here
      }, 200);
    });
  };

  // ============================================================
  // TABBED MEGA MENU — tab activation, keyboard nav, ARIA wiring
  // ============================================================
  MM.initTabs = function () {
    var $tabContainers = $('[data-mega-menu-tabs]');

    $tabContainers.each(function () {
      var $tabContainer = $(this);

      if ($tabContainer.data('tabs-bound')) { return; }
      $tabContainer.data('tabs-bound', true);

      var $tabButtons = $tabContainer.find('> .mega-menu__tab-rail > .mega-menu__tab-button');
      var $tabPanels = $tabContainer.find('> .mega-menu__tab-panels > .mega-menu__tab-panel');

      function activateTab($button) {
        var targetId = $button.attr('data-tab-target');
        if (!targetId) { return; }

        $tabButtons.removeClass('is-active').attr('aria-selected', 'false').attr('tabindex', '-1');
        $button.addClass('is-active').attr('aria-selected', 'true').attr('tabindex', '0');
        $tabPanels.removeClass('is-active').attr('hidden', 'hidden');

        var $targetPanel = $tabContainer.find('#' + targetId);
        $targetPanel.addClass('is-active').removeAttr('hidden');
      }

      $tabButtons.on('mouseenter', function () {
        if (window.matchMedia('(min-width: 769px)').matches) { activateTab($(this)); }
      });

      $tabButtons.on('click touchend', function (e) {
        e.preventDefault();
        activateTab($(this));
        var $panel = $tabContainer.find('#' + $(this).attr('data-tab-target'));
        $panel.find('a').first().focus();
      });

      $tabButtons.on('focus', function () { activateTab($(this)); });

      $tabButtons.on('keydown', function (e) {
        var $current = $(this);
        var $target;
        switch (e.key) {
          case 'ArrowDown':
          case 'ArrowRight':
            $target = $current.next('.mega-menu__tab-button');
            if (!$target.length) { $target = $tabButtons.first(); }
            break;
          case 'ArrowUp':
          case 'ArrowLeft':
            $target = $current.prev('.mega-menu__tab-button');
            if (!$target.length) { $target = $tabButtons.last(); }
            break;
          case 'Home':
            $target = $tabButtons.first();
            break;
          case 'End':
            $target = $tabButtons.last();
            break;
          default:
            return;
        }
        if ($target && $target.length) { e.preventDefault(); $target.focus(); }
      });
    });
  };

  MM.buildMobileAccordion = function ($clone) {
    var $container = $clone.find('[data-mega-menu-tabs]');
    if (!$container.length) { return; }

    $container.data('tabs-bound', true);
    $container.addClass('mega-menu__tabs--mobile');

    var $rail = $container.children('.mega-menu__tab-rail');
    var $panelsWrap = $container.children('.mega-menu__tab-panels');
    var $buttons = $rail.children('.mega-menu__tab-button');

    var self = this;
    $buttons.each(function () {
      var $btn = $(this);
      var targetId = $btn.attr('data-tab-target');
      var $panel = $panelsWrap.children('[id="' + targetId + '"]');

      $btn.removeClass('is-active').attr('aria-expanded', 'false').attr('aria-selected', 'false').attr('tabindex', '0');
      $panel.removeClass('is-active').removeAttr('hidden');

      $panel.insertAfter($btn);
      self.buildColumnAccordions($panel);

      $btn.on('click touchend', function (e) {
        e.preventDefault();
        var isOpen = $btn.hasClass('is-active');
        $buttons.removeClass('is-active').attr('aria-expanded', 'false');
        $rail.children('.mega-menu__tab-panel').removeClass('is-active');
        if (!isOpen) {
          $btn.addClass('is-active').attr('aria-expanded', 'true');
          $panel.addClass('is-active');
        }
      });
    });

    $panelsWrap.remove();
  };

  MM.buildColumnAccordions = function ($panel) {
    var $cols = $panel.find('.mega-menu__panel-cols > .mega-menu__panel-column');
    $cols.each(function (index) {
      var $col = $(this);
      var $heading = $col.children('.menu__heading').first();
      var $list = $col.children('ul.mega-menu__linklist').first();
      if (!$heading.length || !$list.length) { return; }

      $col.addClass('mm-col-accordion');
      $heading.attr('role', 'button').attr('tabindex', '0');

      if (index === 0) {
        $col.addClass('is-open');
        $heading.attr('aria-expanded', 'true');
        $list.removeAttr('hidden');
      } else {
        $heading.attr('aria-expanded', 'false');
        $list.attr('hidden', 'hidden');
      }

      var toggle = function (e) {
        if (e) { e.preventDefault(); }
        if ($col.hasClass('is-open')) {
          $col.removeClass('is-open');
          $heading.attr('aria-expanded', 'false');
          $list.attr('hidden', 'hidden');
        } else {
          $col.addClass('is-open');
          $heading.attr('aria-expanded', 'true');
          $list.removeAttr('hidden');
        }
      };

      $heading.on('click touchend', toggle);
      $heading.on('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { toggle(e); }
      });
    });
  };

  // ------------------------------------------------------------
  // Theme editor + legacy helpers
  // ------------------------------------------------------------
  MM.showThemeEditorState = function (id, $section) {
    this._buildDesktop && this._registry && (function (self) {
      // Make sure the panel exists before forcing it open in the editor
      var $sec = $('.mega-menu__' + id);
      if (!$sec.closest('.header__item, .vertical-header__first-level').length) {
        var handle = $sec.find('.mega-menu').data('parent-link');
        if (handle) { self._buildDesktop(handle); }
      }
    })(this);
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').addClass('is-active');
    if (this.initTabs) { this.initTabs(); }
  };

  MM.hideThemeEditorState = function (id, $section) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--force-show');
    $('.mega-menu__' + id + ' .mega-menu').prev('.header__link').removeClass('is-active');
  };

  MM.displayMenu = function (id) {
    $('.mega-menu').removeClass('mega-menu--show');
    $('.mega-menu__' + id + ' .mega-menu').addClass('mega-menu--show');
  };

  MM.hideMenu = function (id) {
    $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
  };

  MM.unload = function ($section) {
    var parentLink = $section.find('.mega-menu').data('parent-link');
    var navLink = $('[data-navlink-handle="' + parentLink + '"]');
    navLink.off();
    navLink.find('.mega-menu__section').remove();
    $('.mega-menu__section, .navbar, .navbar-item, .header__brand, .header__search').off();
    if (parentLink && this._registry[parentLink]) {
      this._registry[parentLink].desktopBuilt = false;
      this._registry[parentLink].mobileBuilt = false;
    }
  };
})();
